__turbopack_context__.v({
  "align-bottom": "Col-module__dGpera__align-bottom",
  "align-middle": "Col-module__dGpera__align-middle",
  "align-top": "Col-module__dGpera__align-top",
  "component": "Col-module__dGpera__component",
  "offset-1": "Col-module__dGpera__offset-1",
  "offset-10": "Col-module__dGpera__offset-10",
  "offset-11": "Col-module__dGpera__offset-11",
  "offset-12": "Col-module__dGpera__offset-12",
  "offset-2": "Col-module__dGpera__offset-2",
  "offset-3": "Col-module__dGpera__offset-3",
  "offset-4": "Col-module__dGpera__offset-4",
  "offset-5": "Col-module__dGpera__offset-5",
  "offset-6": "Col-module__dGpera__offset-6",
  "offset-7": "Col-module__dGpera__offset-7",
  "offset-8": "Col-module__dGpera__offset-8",
  "offset-9": "Col-module__dGpera__offset-9",
  "offset-desktop-1": "Col-module__dGpera__offset-desktop-1",
  "offset-desktop-10": "Col-module__dGpera__offset-desktop-10",
  "offset-desktop-11": "Col-module__dGpera__offset-desktop-11",
  "offset-desktop-12": "Col-module__dGpera__offset-desktop-12",
  "offset-desktop-2": "Col-module__dGpera__offset-desktop-2",
  "offset-desktop-3": "Col-module__dGpera__offset-desktop-3",
  "offset-desktop-4": "Col-module__dGpera__offset-desktop-4",
  "offset-desktop-5": "Col-module__dGpera__offset-desktop-5",
  "offset-desktop-6": "Col-module__dGpera__offset-desktop-6",
  "offset-desktop-7": "Col-module__dGpera__offset-desktop-7",
  "offset-desktop-8": "Col-module__dGpera__offset-desktop-8",
  "offset-desktop-9": "Col-module__dGpera__offset-desktop-9",
  "offset-desktop-l-1": "Col-module__dGpera__offset-desktop-l-1",
  "offset-desktop-l-10": "Col-module__dGpera__offset-desktop-l-10",
  "offset-desktop-l-11": "Col-module__dGpera__offset-desktop-l-11",
  "offset-desktop-l-12": "Col-module__dGpera__offset-desktop-l-12",
  "offset-desktop-l-2": "Col-module__dGpera__offset-desktop-l-2",
  "offset-desktop-l-3": "Col-module__dGpera__offset-desktop-l-3",
  "offset-desktop-l-4": "Col-module__dGpera__offset-desktop-l-4",
  "offset-desktop-l-5": "Col-module__dGpera__offset-desktop-l-5",
  "offset-desktop-l-6": "Col-module__dGpera__offset-desktop-l-6",
  "offset-desktop-l-7": "Col-module__dGpera__offset-desktop-l-7",
  "offset-desktop-l-8": "Col-module__dGpera__offset-desktop-l-8",
  "offset-desktop-l-9": "Col-module__dGpera__offset-desktop-l-9",
  "offset-desktop-m-1": "Col-module__dGpera__offset-desktop-m-1",
  "offset-desktop-m-10": "Col-module__dGpera__offset-desktop-m-10",
  "offset-desktop-m-11": "Col-module__dGpera__offset-desktop-m-11",
  "offset-desktop-m-12": "Col-module__dGpera__offset-desktop-m-12",
  "offset-desktop-m-2": "Col-module__dGpera__offset-desktop-m-2",
  "offset-desktop-m-3": "Col-module__dGpera__offset-desktop-m-3",
  "offset-desktop-m-4": "Col-module__dGpera__offset-desktop-m-4",
  "offset-desktop-m-5": "Col-module__dGpera__offset-desktop-m-5",
  "offset-desktop-m-6": "Col-module__dGpera__offset-desktop-m-6",
  "offset-desktop-m-7": "Col-module__dGpera__offset-desktop-m-7",
  "offset-desktop-m-8": "Col-module__dGpera__offset-desktop-m-8",
  "offset-desktop-m-9": "Col-module__dGpera__offset-desktop-m-9",
  "offset-desktop-s-1": "Col-module__dGpera__offset-desktop-s-1",
  "offset-desktop-s-10": "Col-module__dGpera__offset-desktop-s-10",
  "offset-desktop-s-11": "Col-module__dGpera__offset-desktop-s-11",
  "offset-desktop-s-12": "Col-module__dGpera__offset-desktop-s-12",
  "offset-desktop-s-2": "Col-module__dGpera__offset-desktop-s-2",
  "offset-desktop-s-3": "Col-module__dGpera__offset-desktop-s-3",
  "offset-desktop-s-4": "Col-module__dGpera__offset-desktop-s-4",
  "offset-desktop-s-5": "Col-module__dGpera__offset-desktop-s-5",
  "offset-desktop-s-6": "Col-module__dGpera__offset-desktop-s-6",
  "offset-desktop-s-7": "Col-module__dGpera__offset-desktop-s-7",
  "offset-desktop-s-8": "Col-module__dGpera__offset-desktop-s-8",
  "offset-desktop-s-9": "Col-module__dGpera__offset-desktop-s-9",
  "offset-mobile-1": "Col-module__dGpera__offset-mobile-1",
  "offset-mobile-10": "Col-module__dGpera__offset-mobile-10",
  "offset-mobile-11": "Col-module__dGpera__offset-mobile-11",
  "offset-mobile-12": "Col-module__dGpera__offset-mobile-12",
  "offset-mobile-2": "Col-module__dGpera__offset-mobile-2",
  "offset-mobile-3": "Col-module__dGpera__offset-mobile-3",
  "offset-mobile-4": "Col-module__dGpera__offset-mobile-4",
  "offset-mobile-5": "Col-module__dGpera__offset-mobile-5",
  "offset-mobile-6": "Col-module__dGpera__offset-mobile-6",
  "offset-mobile-7": "Col-module__dGpera__offset-mobile-7",
  "offset-mobile-8": "Col-module__dGpera__offset-mobile-8",
  "offset-mobile-9": "Col-module__dGpera__offset-mobile-9",
  "offset-tablet-1": "Col-module__dGpera__offset-tablet-1",
  "offset-tablet-10": "Col-module__dGpera__offset-tablet-10",
  "offset-tablet-11": "Col-module__dGpera__offset-tablet-11",
  "offset-tablet-12": "Col-module__dGpera__offset-tablet-12",
  "offset-tablet-2": "Col-module__dGpera__offset-tablet-2",
  "offset-tablet-3": "Col-module__dGpera__offset-tablet-3",
  "offset-tablet-4": "Col-module__dGpera__offset-tablet-4",
  "offset-tablet-5": "Col-module__dGpera__offset-tablet-5",
  "offset-tablet-6": "Col-module__dGpera__offset-tablet-6",
  "offset-tablet-7": "Col-module__dGpera__offset-tablet-7",
  "offset-tablet-8": "Col-module__dGpera__offset-tablet-8",
  "offset-tablet-9": "Col-module__dGpera__offset-tablet-9",
  "offset-tablet-l-1": "Col-module__dGpera__offset-tablet-l-1",
  "offset-tablet-l-10": "Col-module__dGpera__offset-tablet-l-10",
  "offset-tablet-l-11": "Col-module__dGpera__offset-tablet-l-11",
  "offset-tablet-l-12": "Col-module__dGpera__offset-tablet-l-12",
  "offset-tablet-l-2": "Col-module__dGpera__offset-tablet-l-2",
  "offset-tablet-l-3": "Col-module__dGpera__offset-tablet-l-3",
  "offset-tablet-l-4": "Col-module__dGpera__offset-tablet-l-4",
  "offset-tablet-l-5": "Col-module__dGpera__offset-tablet-l-5",
  "offset-tablet-l-6": "Col-module__dGpera__offset-tablet-l-6",
  "offset-tablet-l-7": "Col-module__dGpera__offset-tablet-l-7",
  "offset-tablet-l-8": "Col-module__dGpera__offset-tablet-l-8",
  "offset-tablet-l-9": "Col-module__dGpera__offset-tablet-l-9",
  "offset-tablet-s-1": "Col-module__dGpera__offset-tablet-s-1",
  "offset-tablet-s-10": "Col-module__dGpera__offset-tablet-s-10",
  "offset-tablet-s-11": "Col-module__dGpera__offset-tablet-s-11",
  "offset-tablet-s-12": "Col-module__dGpera__offset-tablet-s-12",
  "offset-tablet-s-2": "Col-module__dGpera__offset-tablet-s-2",
  "offset-tablet-s-3": "Col-module__dGpera__offset-tablet-s-3",
  "offset-tablet-s-4": "Col-module__dGpera__offset-tablet-s-4",
  "offset-tablet-s-5": "Col-module__dGpera__offset-tablet-s-5",
  "offset-tablet-s-6": "Col-module__dGpera__offset-tablet-s-6",
  "offset-tablet-s-7": "Col-module__dGpera__offset-tablet-s-7",
  "offset-tablet-s-8": "Col-module__dGpera__offset-tablet-s-8",
  "offset-tablet-s-9": "Col-module__dGpera__offset-tablet-s-9",
  "order-1": "Col-module__dGpera__order-1",
  "order-10": "Col-module__dGpera__order-10",
  "order-11": "Col-module__dGpera__order-11",
  "order-12": "Col-module__dGpera__order-12",
  "order-2": "Col-module__dGpera__order-2",
  "order-3": "Col-module__dGpera__order-3",
  "order-4": "Col-module__dGpera__order-4",
  "order-5": "Col-module__dGpera__order-5",
  "order-6": "Col-module__dGpera__order-6",
  "order-7": "Col-module__dGpera__order-7",
  "order-8": "Col-module__dGpera__order-8",
  "order-9": "Col-module__dGpera__order-9",
  "order-desktop-1": "Col-module__dGpera__order-desktop-1",
  "order-desktop-10": "Col-module__dGpera__order-desktop-10",
  "order-desktop-11": "Col-module__dGpera__order-desktop-11",
  "order-desktop-12": "Col-module__dGpera__order-desktop-12",
  "order-desktop-2": "Col-module__dGpera__order-desktop-2",
  "order-desktop-3": "Col-module__dGpera__order-desktop-3",
  "order-desktop-4": "Col-module__dGpera__order-desktop-4",
  "order-desktop-5": "Col-module__dGpera__order-desktop-5",
  "order-desktop-6": "Col-module__dGpera__order-desktop-6",
  "order-desktop-7": "Col-module__dGpera__order-desktop-7",
  "order-desktop-8": "Col-module__dGpera__order-desktop-8",
  "order-desktop-9": "Col-module__dGpera__order-desktop-9",
  "order-desktop-first": "Col-module__dGpera__order-desktop-first",
  "order-desktop-l-1": "Col-module__dGpera__order-desktop-l-1",
  "order-desktop-l-10": "Col-module__dGpera__order-desktop-l-10",
  "order-desktop-l-11": "Col-module__dGpera__order-desktop-l-11",
  "order-desktop-l-12": "Col-module__dGpera__order-desktop-l-12",
  "order-desktop-l-2": "Col-module__dGpera__order-desktop-l-2",
  "order-desktop-l-3": "Col-module__dGpera__order-desktop-l-3",
  "order-desktop-l-4": "Col-module__dGpera__order-desktop-l-4",
  "order-desktop-l-5": "Col-module__dGpera__order-desktop-l-5",
  "order-desktop-l-6": "Col-module__dGpera__order-desktop-l-6",
  "order-desktop-l-7": "Col-module__dGpera__order-desktop-l-7",
  "order-desktop-l-8": "Col-module__dGpera__order-desktop-l-8",
  "order-desktop-l-9": "Col-module__dGpera__order-desktop-l-9",
  "order-desktop-l-first": "Col-module__dGpera__order-desktop-l-first",
  "order-desktop-l-last": "Col-module__dGpera__order-desktop-l-last",
  "order-desktop-last": "Col-module__dGpera__order-desktop-last",
  "order-desktop-m-1": "Col-module__dGpera__order-desktop-m-1",
  "order-desktop-m-10": "Col-module__dGpera__order-desktop-m-10",
  "order-desktop-m-11": "Col-module__dGpera__order-desktop-m-11",
  "order-desktop-m-12": "Col-module__dGpera__order-desktop-m-12",
  "order-desktop-m-2": "Col-module__dGpera__order-desktop-m-2",
  "order-desktop-m-3": "Col-module__dGpera__order-desktop-m-3",
  "order-desktop-m-4": "Col-module__dGpera__order-desktop-m-4",
  "order-desktop-m-5": "Col-module__dGpera__order-desktop-m-5",
  "order-desktop-m-6": "Col-module__dGpera__order-desktop-m-6",
  "order-desktop-m-7": "Col-module__dGpera__order-desktop-m-7",
  "order-desktop-m-8": "Col-module__dGpera__order-desktop-m-8",
  "order-desktop-m-9": "Col-module__dGpera__order-desktop-m-9",
  "order-desktop-m-first": "Col-module__dGpera__order-desktop-m-first",
  "order-desktop-m-last": "Col-module__dGpera__order-desktop-m-last",
  "order-desktop-s-1": "Col-module__dGpera__order-desktop-s-1",
  "order-desktop-s-10": "Col-module__dGpera__order-desktop-s-10",
  "order-desktop-s-11": "Col-module__dGpera__order-desktop-s-11",
  "order-desktop-s-12": "Col-module__dGpera__order-desktop-s-12",
  "order-desktop-s-2": "Col-module__dGpera__order-desktop-s-2",
  "order-desktop-s-3": "Col-module__dGpera__order-desktop-s-3",
  "order-desktop-s-4": "Col-module__dGpera__order-desktop-s-4",
  "order-desktop-s-5": "Col-module__dGpera__order-desktop-s-5",
  "order-desktop-s-6": "Col-module__dGpera__order-desktop-s-6",
  "order-desktop-s-7": "Col-module__dGpera__order-desktop-s-7",
  "order-desktop-s-8": "Col-module__dGpera__order-desktop-s-8",
  "order-desktop-s-9": "Col-module__dGpera__order-desktop-s-9",
  "order-desktop-s-first": "Col-module__dGpera__order-desktop-s-first",
  "order-desktop-s-last": "Col-module__dGpera__order-desktop-s-last",
  "order-first": "Col-module__dGpera__order-first",
  "order-last": "Col-module__dGpera__order-last",
  "order-mobile-1": "Col-module__dGpera__order-mobile-1",
  "order-mobile-10": "Col-module__dGpera__order-mobile-10",
  "order-mobile-11": "Col-module__dGpera__order-mobile-11",
  "order-mobile-12": "Col-module__dGpera__order-mobile-12",
  "order-mobile-2": "Col-module__dGpera__order-mobile-2",
  "order-mobile-3": "Col-module__dGpera__order-mobile-3",
  "order-mobile-4": "Col-module__dGpera__order-mobile-4",
  "order-mobile-5": "Col-module__dGpera__order-mobile-5",
  "order-mobile-6": "Col-module__dGpera__order-mobile-6",
  "order-mobile-7": "Col-module__dGpera__order-mobile-7",
  "order-mobile-8": "Col-module__dGpera__order-mobile-8",
  "order-mobile-9": "Col-module__dGpera__order-mobile-9",
  "order-mobile-first": "Col-module__dGpera__order-mobile-first",
  "order-mobile-last": "Col-module__dGpera__order-mobile-last",
  "order-tablet-1": "Col-module__dGpera__order-tablet-1",
  "order-tablet-10": "Col-module__dGpera__order-tablet-10",
  "order-tablet-11": "Col-module__dGpera__order-tablet-11",
  "order-tablet-12": "Col-module__dGpera__order-tablet-12",
  "order-tablet-2": "Col-module__dGpera__order-tablet-2",
  "order-tablet-3": "Col-module__dGpera__order-tablet-3",
  "order-tablet-4": "Col-module__dGpera__order-tablet-4",
  "order-tablet-5": "Col-module__dGpera__order-tablet-5",
  "order-tablet-6": "Col-module__dGpera__order-tablet-6",
  "order-tablet-7": "Col-module__dGpera__order-tablet-7",
  "order-tablet-8": "Col-module__dGpera__order-tablet-8",
  "order-tablet-9": "Col-module__dGpera__order-tablet-9",
  "order-tablet-first": "Col-module__dGpera__order-tablet-first",
  "order-tablet-l-1": "Col-module__dGpera__order-tablet-l-1",
  "order-tablet-l-10": "Col-module__dGpera__order-tablet-l-10",
  "order-tablet-l-11": "Col-module__dGpera__order-tablet-l-11",
  "order-tablet-l-12": "Col-module__dGpera__order-tablet-l-12",
  "order-tablet-l-2": "Col-module__dGpera__order-tablet-l-2",
  "order-tablet-l-3": "Col-module__dGpera__order-tablet-l-3",
  "order-tablet-l-4": "Col-module__dGpera__order-tablet-l-4",
  "order-tablet-l-5": "Col-module__dGpera__order-tablet-l-5",
  "order-tablet-l-6": "Col-module__dGpera__order-tablet-l-6",
  "order-tablet-l-7": "Col-module__dGpera__order-tablet-l-7",
  "order-tablet-l-8": "Col-module__dGpera__order-tablet-l-8",
  "order-tablet-l-9": "Col-module__dGpera__order-tablet-l-9",
  "order-tablet-l-first": "Col-module__dGpera__order-tablet-l-first",
  "order-tablet-l-last": "Col-module__dGpera__order-tablet-l-last",
  "order-tablet-last": "Col-module__dGpera__order-tablet-last",
  "order-tablet-s-1": "Col-module__dGpera__order-tablet-s-1",
  "order-tablet-s-10": "Col-module__dGpera__order-tablet-s-10",
  "order-tablet-s-11": "Col-module__dGpera__order-tablet-s-11",
  "order-tablet-s-12": "Col-module__dGpera__order-tablet-s-12",
  "order-tablet-s-2": "Col-module__dGpera__order-tablet-s-2",
  "order-tablet-s-3": "Col-module__dGpera__order-tablet-s-3",
  "order-tablet-s-4": "Col-module__dGpera__order-tablet-s-4",
  "order-tablet-s-5": "Col-module__dGpera__order-tablet-s-5",
  "order-tablet-s-6": "Col-module__dGpera__order-tablet-s-6",
  "order-tablet-s-7": "Col-module__dGpera__order-tablet-s-7",
  "order-tablet-s-8": "Col-module__dGpera__order-tablet-s-8",
  "order-tablet-s-9": "Col-module__dGpera__order-tablet-s-9",
  "order-tablet-s-first": "Col-module__dGpera__order-tablet-s-first",
  "order-tablet-s-last": "Col-module__dGpera__order-tablet-s-last",
  "width-1": "Col-module__dGpera__width-1",
  "width-10": "Col-module__dGpera__width-10",
  "width-11": "Col-module__dGpera__width-11",
  "width-12": "Col-module__dGpera__width-12",
  "width-2": "Col-module__dGpera__width-2",
  "width-3": "Col-module__dGpera__width-3",
  "width-4": "Col-module__dGpera__width-4",
  "width-5": "Col-module__dGpera__width-5",
  "width-6": "Col-module__dGpera__width-6",
  "width-7": "Col-module__dGpera__width-7",
  "width-8": "Col-module__dGpera__width-8",
  "width-9": "Col-module__dGpera__width-9",
  "width-auto": "Col-module__dGpera__width-auto",
  "width-available": "Col-module__dGpera__width-available",
  "width-desktop-1": "Col-module__dGpera__width-desktop-1",
  "width-desktop-10": "Col-module__dGpera__width-desktop-10",
  "width-desktop-11": "Col-module__dGpera__width-desktop-11",
  "width-desktop-12": "Col-module__dGpera__width-desktop-12",
  "width-desktop-2": "Col-module__dGpera__width-desktop-2",
  "width-desktop-3": "Col-module__dGpera__width-desktop-3",
  "width-desktop-4": "Col-module__dGpera__width-desktop-4",
  "width-desktop-5": "Col-module__dGpera__width-desktop-5",
  "width-desktop-6": "Col-module__dGpera__width-desktop-6",
  "width-desktop-7": "Col-module__dGpera__width-desktop-7",
  "width-desktop-8": "Col-module__dGpera__width-desktop-8",
  "width-desktop-9": "Col-module__dGpera__width-desktop-9",
  "width-desktop-auto": "Col-module__dGpera__width-desktop-auto",
  "width-desktop-available": "Col-module__dGpera__width-desktop-available",
  "width-desktop-l-1": "Col-module__dGpera__width-desktop-l-1",
  "width-desktop-l-10": "Col-module__dGpera__width-desktop-l-10",
  "width-desktop-l-11": "Col-module__dGpera__width-desktop-l-11",
  "width-desktop-l-12": "Col-module__dGpera__width-desktop-l-12",
  "width-desktop-l-2": "Col-module__dGpera__width-desktop-l-2",
  "width-desktop-l-3": "Col-module__dGpera__width-desktop-l-3",
  "width-desktop-l-4": "Col-module__dGpera__width-desktop-l-4",
  "width-desktop-l-5": "Col-module__dGpera__width-desktop-l-5",
  "width-desktop-l-6": "Col-module__dGpera__width-desktop-l-6",
  "width-desktop-l-7": "Col-module__dGpera__width-desktop-l-7",
  "width-desktop-l-8": "Col-module__dGpera__width-desktop-l-8",
  "width-desktop-l-9": "Col-module__dGpera__width-desktop-l-9",
  "width-desktop-l-auto": "Col-module__dGpera__width-desktop-l-auto",
  "width-desktop-l-available": "Col-module__dGpera__width-desktop-l-available",
  "width-desktop-m-1": "Col-module__dGpera__width-desktop-m-1",
  "width-desktop-m-10": "Col-module__dGpera__width-desktop-m-10",
  "width-desktop-m-11": "Col-module__dGpera__width-desktop-m-11",
  "width-desktop-m-12": "Col-module__dGpera__width-desktop-m-12",
  "width-desktop-m-2": "Col-module__dGpera__width-desktop-m-2",
  "width-desktop-m-3": "Col-module__dGpera__width-desktop-m-3",
  "width-desktop-m-4": "Col-module__dGpera__width-desktop-m-4",
  "width-desktop-m-5": "Col-module__dGpera__width-desktop-m-5",
  "width-desktop-m-6": "Col-module__dGpera__width-desktop-m-6",
  "width-desktop-m-7": "Col-module__dGpera__width-desktop-m-7",
  "width-desktop-m-8": "Col-module__dGpera__width-desktop-m-8",
  "width-desktop-m-9": "Col-module__dGpera__width-desktop-m-9",
  "width-desktop-m-auto": "Col-module__dGpera__width-desktop-m-auto",
  "width-desktop-m-available": "Col-module__dGpera__width-desktop-m-available",
  "width-desktop-s-1": "Col-module__dGpera__width-desktop-s-1",
  "width-desktop-s-10": "Col-module__dGpera__width-desktop-s-10",
  "width-desktop-s-11": "Col-module__dGpera__width-desktop-s-11",
  "width-desktop-s-12": "Col-module__dGpera__width-desktop-s-12",
  "width-desktop-s-2": "Col-module__dGpera__width-desktop-s-2",
  "width-desktop-s-3": "Col-module__dGpera__width-desktop-s-3",
  "width-desktop-s-4": "Col-module__dGpera__width-desktop-s-4",
  "width-desktop-s-5": "Col-module__dGpera__width-desktop-s-5",
  "width-desktop-s-6": "Col-module__dGpera__width-desktop-s-6",
  "width-desktop-s-7": "Col-module__dGpera__width-desktop-s-7",
  "width-desktop-s-8": "Col-module__dGpera__width-desktop-s-8",
  "width-desktop-s-9": "Col-module__dGpera__width-desktop-s-9",
  "width-desktop-s-auto": "Col-module__dGpera__width-desktop-s-auto",
  "width-desktop-s-available": "Col-module__dGpera__width-desktop-s-available",
  "width-mobile-1": "Col-module__dGpera__width-mobile-1",
  "width-mobile-10": "Col-module__dGpera__width-mobile-10",
  "width-mobile-11": "Col-module__dGpera__width-mobile-11",
  "width-mobile-12": "Col-module__dGpera__width-mobile-12",
  "width-mobile-2": "Col-module__dGpera__width-mobile-2",
  "width-mobile-3": "Col-module__dGpera__width-mobile-3",
  "width-mobile-4": "Col-module__dGpera__width-mobile-4",
  "width-mobile-5": "Col-module__dGpera__width-mobile-5",
  "width-mobile-6": "Col-module__dGpera__width-mobile-6",
  "width-mobile-7": "Col-module__dGpera__width-mobile-7",
  "width-mobile-8": "Col-module__dGpera__width-mobile-8",
  "width-mobile-9": "Col-module__dGpera__width-mobile-9",
  "width-mobile-auto": "Col-module__dGpera__width-mobile-auto",
  "width-mobile-available": "Col-module__dGpera__width-mobile-available",
  "width-tablet-1": "Col-module__dGpera__width-tablet-1",
  "width-tablet-10": "Col-module__dGpera__width-tablet-10",
  "width-tablet-11": "Col-module__dGpera__width-tablet-11",
  "width-tablet-12": "Col-module__dGpera__width-tablet-12",
  "width-tablet-2": "Col-module__dGpera__width-tablet-2",
  "width-tablet-3": "Col-module__dGpera__width-tablet-3",
  "width-tablet-4": "Col-module__dGpera__width-tablet-4",
  "width-tablet-5": "Col-module__dGpera__width-tablet-5",
  "width-tablet-6": "Col-module__dGpera__width-tablet-6",
  "width-tablet-7": "Col-module__dGpera__width-tablet-7",
  "width-tablet-8": "Col-module__dGpera__width-tablet-8",
  "width-tablet-9": "Col-module__dGpera__width-tablet-9",
  "width-tablet-auto": "Col-module__dGpera__width-tablet-auto",
  "width-tablet-available": "Col-module__dGpera__width-tablet-available",
  "width-tablet-l-1": "Col-module__dGpera__width-tablet-l-1",
  "width-tablet-l-10": "Col-module__dGpera__width-tablet-l-10",
  "width-tablet-l-11": "Col-module__dGpera__width-tablet-l-11",
  "width-tablet-l-12": "Col-module__dGpera__width-tablet-l-12",
  "width-tablet-l-2": "Col-module__dGpera__width-tablet-l-2",
  "width-tablet-l-3": "Col-module__dGpera__width-tablet-l-3",
  "width-tablet-l-4": "Col-module__dGpera__width-tablet-l-4",
  "width-tablet-l-5": "Col-module__dGpera__width-tablet-l-5",
  "width-tablet-l-6": "Col-module__dGpera__width-tablet-l-6",
  "width-tablet-l-7": "Col-module__dGpera__width-tablet-l-7",
  "width-tablet-l-8": "Col-module__dGpera__width-tablet-l-8",
  "width-tablet-l-9": "Col-module__dGpera__width-tablet-l-9",
  "width-tablet-l-auto": "Col-module__dGpera__width-tablet-l-auto",
  "width-tablet-l-available": "Col-module__dGpera__width-tablet-l-available",
  "width-tablet-s-1": "Col-module__dGpera__width-tablet-s-1",
  "width-tablet-s-10": "Col-module__dGpera__width-tablet-s-10",
  "width-tablet-s-11": "Col-module__dGpera__width-tablet-s-11",
  "width-tablet-s-12": "Col-module__dGpera__width-tablet-s-12",
  "width-tablet-s-2": "Col-module__dGpera__width-tablet-s-2",
  "width-tablet-s-3": "Col-module__dGpera__width-tablet-s-3",
  "width-tablet-s-4": "Col-module__dGpera__width-tablet-s-4",
  "width-tablet-s-5": "Col-module__dGpera__width-tablet-s-5",
  "width-tablet-s-6": "Col-module__dGpera__width-tablet-s-6",
  "width-tablet-s-7": "Col-module__dGpera__width-tablet-s-7",
  "width-tablet-s-8": "Col-module__dGpera__width-tablet-s-8",
  "width-tablet-s-9": "Col-module__dGpera__width-tablet-s-9",
  "width-tablet-s-auto": "Col-module__dGpera__width-tablet-s-auto",
  "width-tablet-s-available": "Col-module__dGpera__width-tablet-s-available",
});
